import type { PidLink } from "../types";

/** Deep link into the P&ID explorer, on the tag the SPOF was matched to.
 *  `focus=1` tells the explorer to flag the tag the visitor was sent to. */
export function pidHref(link: PidLink): string {
  return `/dashboard/pid-explorer?plant=${link.power_plant_id}&pid=${link.pid_id}&kks=${link.kks_id}&focus=1`;
}

/** Deep link to the digital record of a SPOF. */
export function spofCardHref(plantId: string, spofId: string): string {
  return `/dashboard/spofs/${encodeURIComponent(plantId)}/${encodeURIComponent(spofId)}`;
}

/** Deep link to one proposed mitigation of a SPOF. */
export function mitigationHref(
  plantId: string,
  spofId: string,
  mitigationId: string,
): string {
  return `${spofCardHref(plantId, spofId)}/mitigations/${encodeURIComponent(mitigationId)}`;
}
